import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import RouteListener from './RouteListener';
import * as ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import AssignmentSummary from './AssignmentSummary';
import AssignmentSlat from './AssignmentSlat';

require('../../css/components/Assignments.scss');

'use strict';

export default class Assignments extends React.Component {
    constructor(props) {
        props.cacheKey = props.cacheKey || 1;
        super(props);
        this.state = { assignments: null, loaded: false, loading: false, cacheKey: this.props.cacheKey, transitionOut: false };

        this.setRouterRef = this.setRouterRef.bind(this);
        this.onAssignmentsClick = this.onAssignmentsClick.bind(this);

        this.onQuestionAnsweredCorrectly = this.onQuestionAnsweredCorrectly.bind(this);
        this.onQuestionAnsweredIncorrectly = this.onQuestionAnsweredIncorrectly.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate() {
        if (this.props.cacheKey !== this.state.cacheKey)
            this.loadData();
    }

    loadData() {
        this.setState({
            loading: true,
        });

        this.props.user.getAssignments(
            result => {
                this.setState({
                    loading: false,
                    loaded: true,
                    cacheKey: this.props.cacheKey,
                    assignments: result
                });
            },
            () => {
                this.setState({
                    loading: false,
                    loaded: false,
                    cacheKey: this.props.cacheKey,
                });
            }
        );
    }

    findAssignment(assignmentId) {
        var assignments = this.state.assignments.assignments;
        var a = assignments.findIndex(a => assignmentId === a.id);

        if (a < 0)
            return null;
        else
            return assignments[a];
    }

    onQuestionAnsweredCorrectly() {
        var encounter = this.state.assignments;
        var assignment = this.findAssignment(this.props.assignmentId);

        if (assignment)
            this.props.user.reportAssessmentResult(encounter, assignment, null, encounter.assessment, true);
    }

    onQuestionAnsweredIncorrectly() {
        var encounter = this.state.assignments;
        var assignment = this.findAssignment(this.props.assignmentId);

        if (assignment)
            this.props.user.reportAssessmentResult(encounter, assignment, null, encounter.assessment, false);
    }

    setRouterRef(ref) {
        this.routerRef = ref;
    }

    onAssignmentsClick(e) {
        this.setState({
            transitionOut: true
        });

        window.setTimeout(() => {
            this.routerRef.history.push(this.props.url);
        }, 10);

        e.preventDefault();
    }

    renderItems(assignmentId, items, keyPrefix) {
        var assets = [];

        for (var i in items) {
            var item = items[i];
            assets.push(
                React.createElement(
                    AssetSlat,
                    {
                        key: keyPrefix + i,
                        parentKey: keyPrefix + i,
                        asset: item.asset,
                        urlHash: this.props.urlHash,
                        languageNames: this.props.languageNames,
                        assignmentId: assignmentId,
                        assignment: item,
                        copy: this.props.copy,
                        languageCode: this.props.languageCode
                    }
                ));
        }

        return React.createElement(
            'ul',
            {
                className: 'assetList'
            },
            assets
        );
    }

    renderAssignments(keyPrefix) {
        var assignments = this.state.assignments.assignments;
        var children = [];

        children.push(
            React.createElement(
                'h2',
                {},
                this.props.copy.assignedOn /* + ' ' + this.state.assignments.dateTime */
            ),
            React.createElement(
                Route,
                {
                    path: '/',
                    component: RouteListener
                },
            )
        );

        for (var a in assignments) {
            var assignment = assignments[a];
            children.push(
                React.createElement(
                    AssignmentSlat,
                    {
                        key: keyPrefix + a,
                        parentKey: keyPrefix + a,
                        assignment: assignment,
                        url: this.props.url,
                        urlHash: this.props.urlHash,
                        copy: this.props.copy,
                        languageCode: this.props.languageCode
                    }
                )
            );
        }

        var ul = React.createElement(
            'ul',
            {
                className: 'assetList'
            },
            children
        );

        return React.createElement(
            Router,
            {},
            ul
        );
    }

    renderAssignment(assignmentId) {
        var assignments = this.state.assignments.assignments;

        var children = [];

        children.push(
            [
                React.createElement(
                    Route,
                    {
                        path: '/',
                        component: RouteListener
                    },
                ),
                React.createElement(
                    "h2",
                    {},
                    React.createElement(
                        'a',
                        { key: "ah", onClick: this.onAssignmentsClick },
                        this.props.copy.backToAssignmentsFrom /* + ' ' + this.state.assignments.dateTime */
                    ),
                )
            ]
        );

        for (var a in assignments) {
            var assignment = assignments[a];

            children.push(
                React.createElement(
                    ReactCSSTransitionGroup,
                    {
                        transitionName: "assignment-title-hidden",
                        transitionAppear: assignment.id !== assignmentId,
                        transitionAppearTimeout: 500,
                        transitionEnter: false,
                        transitionLeave: false
                    },
                    React.createElement(
                        AssignmentSlat,
                        {
                            key: "at-" + assignment.id,
                            className: assignment.id !== assignmentId ? "assignment-title-hidden" : "",
                            parentKey: assignment.id,
                            assignment: assignment,
                            copy: this.props.copy,
                            languageCode: this.props.languageCode
                        }
                    )
                )
            );

            if (assignment.id === assignmentId)
                children.push(
                    [
                        React.createElement(
                            ReactCSSTransitionGroup,
                            {
                                transitionName: "assignment",
                                transitionAppear: true,
                                transitionAppearTimeout: 500,
                                transitionEnter: false,
                                transitionLeave: false
                            },
                            React.createElement(
                                "div",
                                { key: "a-" + assignment.id, className: "assignment" },
                                [
                                    React.createElement(
                                        AssignmentSummary,
                                        {
                                            copy: this.props.copy,
                                            encounter: this.state.assignments,
                                            assignment: assignment,
                                            url: this.props.url,
                                            urlHash: this.props.urlHash,
                                            onQuestionAnsweredCorrectly: this.onQuestionAnsweredCorrectly,
                                            onQuestionAnsweredIncorrectly: this.onQuestionAnsweredIncorrectly,
                                            languageCode: this.props.languageCode,
                                            libraryUrl: this.props.libraryUrl
                                        }
                                    ),
                                    this.renderItems(assignment.id, assignment.items)
                                ]
                            )
                        )
                    ]
                );
        }

        var ul = React.createElement(
            'ul',
            {
                className: 'assetList'
            },
            children
        );

        return React.createElement(
            Router,
            { ref: this.setRouterRef },
            ul
        );
    }

    render() {
        if (this.state.loading)
            return 'Loading...';

        if (!this.state.loaded)
            return 'Loading failed.';

        return React.createElement(
            'div',
            { className: "assignments" },
            this.state.assignments.assignments.length ?
                    this.props.assignmentId ? this.renderAssignment(this.props.assignmentId) : this.renderAssignments("a-") :
                "No Assignments found for this Encounter."
        );
    }
}